import Service from './Service';

export default class ComplaintTypeService extends Service{
    constructor() {
        super();
        this.baseURL = 'complaintType';
    }
}